document.addEventListener('DOMContentLoaded', () => {

  const fadeInUpElements = document.querySelectorAll('.fade-in-up');
  const numbers = document.querySelectorAll('.number');

  if (fadeInUpElements.length > 0 || numbers.length > 0) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          } else {
            entry.target.classList.remove('visible');
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    fadeInUpElements.forEach((element) => observer.observe(element));
    numbers.forEach((number) => observer.observe(number));
  }

});